/* product-modal ピンチズーム・ダブルタップリセット */
(function () {
  function initPinchZoom(container) {
    var img = container.querySelector('img');
    if (!img || container.dataset.pinchInit) return;
    container.dataset.pinchInit = '1';

    var scale = 1, lastScale = 1;
    var tx = 0, ty = 0, lastTx = 0, lastTy = 0;
    var initDist = 0, startX = 0, startY = 0;
    var lastTap = 0;

    img.style.transformOrigin = 'center center';
    img.style.willChange = 'transform';

    function applyTransform() {
      img.style.transform = scale === 1
        ? ''
        : 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    }

    function resetTransform() {
      scale = lastScale = 1;
      tx = ty = lastTx = lastTy = 0;
      img.style.transform = '';
    }

    container.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        initDist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        lastScale = scale;
      } else if (e.touches.length === 1 && scale > 1) {
        startX = e.touches[0].clientX - lastTx;
        startY = e.touches[0].clientY - lastTy;
      }
      var now = Date.now();
      if (now - lastTap < 280 && e.touches.length === 1) {
        resetTransform();
      }
      lastTap = now;
    }, { passive: false });

    container.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        var dist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        scale = Math.min(Math.max(lastScale * (dist / initDist), 1), 3.5);
        applyTransform();
      } else if (e.touches.length === 1 && scale > 1) {
        e.preventDefault();
        tx = e.touches[0].clientX - startX;
        ty = e.touches[0].clientY - startY;
        applyTransform();
      }
    }, { passive: false });

    container.addEventListener('touchend', function () {
      if (scale < 1.05) resetTransform();
      lastTx = tx;
      lastTy = ty;
    });
  }

  function attachToModal(modal) {
    modal.querySelectorAll('.product__media-item').forEach(function (item) {
      initPinchZoom(item);
    });
    new MutationObserver(function () {
      modal.querySelectorAll('.product__media-item').forEach(function (item) {
        initPinchZoom(item);
      });
    }).observe(modal, { childList: true, subtree: true, attributes: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('product-modal');
    if (modal) attachToModal(modal);
  });
})();
